export default "__VITE_ASSET__Dleycnb2__"